module.exports = __webpack_public_path__ + "static/media/track-by-id.dd36c0f8.svg";